<template>
  <div>
    <!-- header -->
    <HeadBar @nameClick = "nameClick"></HeadBar>
    <div class="conent-box">
      <div v-if="foundEnd">
        <!--步骤条-->
        <el-steps :active="active" finish-status="success" align-center>
          <el-step title="上传工资表"></el-step>
          <el-step title="核对数据"></el-step>
          <el-step title="预览及发送"></el-step>
        </el-steps>
        <!--内容区域-->
        <el-form ref="form" :model="form" :label-width="active===0?'110px':'200px'" size="mini">
          <!--第一步-->
          <div class="found-first" v-if="active===0">
            <!--薪资类型-->
            <el-form-item label="薪资类型：" style="position:relative;">
              <el-select v-model="form.salaryName" value-key="menu" placeholder="请选择薪资类型" @change="selectSalaryType">
                <el-option v-for="item in salaryTypeData" :key="item.salaryTypeCode" :label="item.salaryTypeNm" :value="item"></el-option>
              </el-select>
              <span size="small" type="primary" style="position:absolute;right:-34px;cursor:pointer;" @click="customSalaryType">自定义薪资类型</span>
            </el-form-item>
            <el-form-item label="所属月份：">
              <div class="block">
                <el-date-picker v-model="formUpload.date" type="month" placeholder="选择日期"></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="工资表：" class="found-first-upload">
              <el-input placeholder="请上传工资表" readonly v-model="form.fileName"></el-input>
              <el-upload class="upload-demo"
                         :action="this.global.baseUrl +'/salaryOrderUploadExcel/uploadExcel'"
                         accept=".xls,.xlsx"
                         name="file"
                         :show-file-list="false"
                         :before-upload="beforeAvatarUpload">
                <span size="small" type="primary" style="text-decoration: underline">点击上传</span>
              </el-upload>
            </el-form-item>
          </div>
          <!--第二步 表格内容栏-->
          <div v-if="active===1">
            <div class="found-two"><b>数据核对</b> &nbsp;&nbsp; 共解析出<span><b>{{pageRequest.total}}</b></span>条有效数据</div>
            <kt-table :data="pageResult" :columns="columns" :current-page="pageRequest.pageNum" :page-size="pageRequest.pageSize"
                      :total="pageRequest.total" @findPage="findPage"></kt-table>
          </div>
          <!--第三步-->
          <div v-if="active===2" class="found-three">
            <div class="found-two">
              <el-divider>发送选项</el-divider>
              <el-divider>效果预览</el-divider>
            </div>
            <el-form-item label="空值处理">
              <el-radio-group v-model="postSalary.nullColumnShow">
                <el-radio :label="0">显示</el-radio>
                <el-radio :label="1">不显示</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="“0”值处理">
              <el-radio-group v-model="postSalary.zeroColumnShow">
                <el-radio :label="0">显示</el-radio>
                <el-radio :label="1">不显示</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="“身份证件号码”对应列">
              <el-select v-model="postSalary.certName" placeholder="请选择" @change="selectCert">
                <el-option v-for="item in selectList" :key="item.id" :label="item.headTitleNm" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="“实发工资”对应列">
              <el-select v-model="postSalary.salaryName" placeholder="请选择" @change="selectSalary">
                <el-option v-for="item in selectList" :key="item.id" :label="item.headTitleNm" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <img src="@/assets/logo.png" class="found-three-img"/>
          </div>
          <el-form-item class="found-bot">
            <el-button @click="prev" v-show="active > 0">上一步</el-button>
            <el-button class='found-btn' @click="next" v-show="active < 2">下一步</el-button>
            <el-button class='found-btn' type="primary" @click="onSubmit" v-show="active === 2">发送</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!--发送成功页面-->
      <div v-if="!foundEnd">
        <el-row style="margin-top:350px;">
          <el-button type="success" @click="goSend">查看发送记录</el-button>
        </el-row>
      </div>
    </div>
    <el-dialog width="600" :visible.sync="dialogVisible" :close-on-click-modal="false">
      <!--添加-->
      <div class="salary-type-add">
        <kt-button icon="fa fa-plus" label="添加薪资类型" size="mini" type="primary" @click="salaryTypeAdd"/>
      </div>
      <!--table表格-->
      <el-table :data="salaryTypeData" border align="center" :header-cell-style="{background:'#f2f7fc',color:'#606266'}" max-height="360" size="mini" style="width:561px;margin:0 auto;" class="salary-type-input">
        <el-table-column header-align="center" align="center" prop="index" label="序号" width="60" type='index'></el-table-column>
        <el-table-column header-align="center" align="center" label="薪资类型" width="300">
          <template slot-scope="scope">
            <el-input v-model="scope.row.salaryTypeNm" v-if="scope.row.edit" size="mini"></el-input>
            <div v-else>{{ scope.row.salaryTypeNm }}</div>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作" width="200">
          <template slot-scope="scope">
            <template v-if="!scope.row.edit">
              <template v-if="scope.row.belong_type === 'company'">
                <kt-button icon="fa fa-edit" label="修改" size="mini" @click="salaryTypeEdit(scope.$index, scope.row)"/>
                <kt-button icon="fa fa-trash" label="删除" size="mini" type="danger" @click="salaryTypeDel(scope.$index, scope.row)"/>
              </template>
              <template v-if="scope.row.belong_type === 'system'">
                <kt-button icon="fa fa-edit" label="修改" size="mini" :disabled="true"/>
                <kt-button icon="fa fa-trash" label="删除" size="mini" type="danger" :disabled="true"/>
              </template>
            </template>
            <template v-if="scope.row.edit">
              <kt-button icon="fa fa-check" label="保存" size="mini" @click="salaryTypeSave(scope.$index, scope.row)"/>
              <kt-button icon="fa fa-times" label="取消" size="mini" type="danger" @click="salaryTypeCancel(scope.$index,scope.row)"/>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
  import HeadBar from '@/components/HeadBar.vue';
  import KtTable from "@/components/KtTable"
  import { formatAll } from "@/utils/datetime"
  import KtButton from "@/components/KtButton"
  export default {
    components:{
      HeadBar,
      KtTable,
      KtButton
    },
    name: 'Found',
    data() {
      return {
        active: 0,
        foundEnd:true, //默认展示第一步内容，当点击发送时，内容全部隐藏
        form: {
            fileName:''
        },
        formUpload:{}, //上传参数
        postSalary:{
          "actualSalary": "",
          "certColumn": "",
          "createTime": "",
          "createUser": "",
          "createUserId": "",
          "disablePaging": true,
          "id": "",
          "nullColumnShow": 0,
          "order": "",
          "pageNum": 0,
          "pageSize": 0,
          "salaryOrderId": "",
          "updateTime": "",
          "updateUser": "",
          "updateUserId": "",
          "zeroColumnShow": 0
        }, //发送参数
        columns:[],
        pageRequest: {},// 第二步获取列表
        pageResult:[],
        selectList:[],  //第三步下拉数据
        salaryOrderId :'',  //
        companyOneId:'',
        dialogVisible: false, // 自定义薪资类型弹窗
        salaryTypeData: [], // 自定义薪资类型数据
      };
    },
    methods: {
      //切换当前用户
      nameClick:function (data) {
        sessionStorage.setItem('companyChange',JSON.stringify(data));
      },
      //下一步
      next() {
        // 如没有上传工资表，则不能进行下一步
        if(this.active === 0 && !this.salaryOrderId){
          return;
        }
        if(this.active === 1){
          this.getSelect();
        }
        if (this.active++ > 1) this.active = 2;return;
      },
      //上一步
      prev() {
        if (this.active-- < 1) this.active = 0;return;
      },
      // -------------- 第一步 -----------------
      // 选择薪资类型
      selectSalaryType: function (data) {
        this.form.salaryName = data.salaryTypeNm;  // 默认展示第一个
        this.formUpload.salaryType = data.salaryTypeCode;
      },
      // 上传文件
      beforeAvatarUpload(file) {
        // let companyChange = JSON.parse(sessionStorage.getItem('companyChange'));
        // if(!this.companyOneId && !companyChange){
        //     this.companyOneId = JSON.parse(sessionStorage.getItem("companyOneId"));
        // }
        var that = this;
        console.log(that.companyOneId);
        if(!this.formUpload.salaryType){
          this.$message({message: '请选择薪资类型！', type: 'error'})
          return false;
        }
        if(!this.formUpload.date){
          this.$message({message: '请选择所属月份！', type: 'error'})
          return false;
        }
        // 限制上传格式
        let acceptList = ['xlsx','xls'];
        let fileType = file.name.split('.').pop().toLowerCase();
        if(acceptList.indexOf(fileType) === -1){
            this.$message({message: '只能上传xlsx/xls格式的文件！ ', type: 'error'});
            return false;
        }
        this.form.fileName = file.name;
        let formData = new FormData();//通过form数据格式来传
        formData.append("file", file); //传文件
        formData.append("date", formatAll(this.formUpload.date)); //日期
        formData.append("companyId", that.companyOneId.id); //公司id
        formData.append("companyName", that.companyOneId.companyName); //公司名称
        formData.append("salaryType", this.formUpload.salaryType); // 薪资类型
        this.$api.found.upLoad(formData).then((res) => {
          if(res.status){
            this.salaryOrderId = res.data;
            this.$message({message: '上传成功！ ', type: 'success'})
          }else{
            this.$message({message: '操作失败, ' + res.msg, type: 'error'})
          }
        });
      },

      // -------------- 第二步 -----------------
      // 获取分页数据
      findPage: function (data) {
        if(data !== null) {
          this.pageRequest = data.pageRequest
        }
        this.pageRequest.disablePaging=false;
        this.pageRequest.order="";
        this.pageRequest.salaryOrderId = this.salaryOrderId;
        this.$api.found.salaryOrder(this.pageRequest).then((res) => {
          if(res.status){
            this.pageRequest.total = res.data.salaryOrderDetails.total; //总数
            this.pageResult = res.data.salaryOrderDetails.list; // 内容
            this.columns = res.data.salaryOrderHeads; //标题
            this.columns.forEach(function(item){
              item.prop = item.headTitleColumn;
              item.label = item.headTitleNm;
              item.minWidth = 120;
            })
          }else{
            this.$message({message: '操作失败, ' + res.msg, type: 'error'})
          }
        }).then(data!=null?data.callback:'')
      },

      // -------------- 第三步 -----------------
      // 获取身份证所对应的下拉内容
      getSelect(){
        let formData = new FormData();//通过form数据格式来传
        formData.append("salaryOrderId", this.salaryOrderId);
        this.$api.found.salarySelect(formData).then((res) => {
          if(res.status){
            this.selectList = res.data;
          }else{
            this.$message({message: '操作失败, ' + res.msg, type: 'error'})
          }
        })
      },
      // 身份证对应列
      selectCert: function (data) {
        this.postSalary.certName = data.headTitleNm;  // 默认展示第一个
        this.postSalary.certColumn = data.headTitleColumn;
      },
      // 实发工资对应列
      selectSalary: function (data) {
        this.postSalary.salaryName = data.headTitleNm;  // 默认展示第一个
        this.postSalary.actualSalary = data.headTitleColumn;
      },
      //发送
      onSubmit() {
        this.postSalary.salaryOrderId = this.salaryOrderId;
        this.$api.found.submitSalary(this.postSalary).then((res) => {
          if(res.status){
            this.foundEnd = false;
            this.$message({
              offset:'300',
              customClass:'found-message',
              duration:2500,
              message: '工资条已发出，由于运营商网络质量、上传了错误数据等原因，可能存在个别工资条发送失败的情况。具体发送结果以发送记录为准。',
              type: 'success'
            });
          }else{
            this.$message({message: '操作失败, ' + res.msg, type: 'error'})
          }
        });
      },
      //查看发送记录
      goSend(){
        this.$router.push('Send');
      },
      // 点击自定义薪资类型
      customSalaryType(){
        this.dialogVisible = true;
      },
      // 查询本企业薪资列表！
      findCompanySalaryTypeList:function(companyId){
        this.$api.found.findCompanySalaryType({companyId:companyId}).then((res) => {
            if(res.status){
                res.data.forEach(function(item){
                    item.edit = false;
                });
                this.salaryTypeData = res.data;
            }else{
                this.$message({message: '获取失败, ' + res.msg, type: 'error'})
            }
        })
      },
      //点击添加
      salaryTypeAdd(){
        this.salaryTypeData.push({edit:true,add:true})
      },
      //点击修改
      salaryTypeEdit(index,val){
        this.salaryTypeData[index].edit = true;
      },
      //点击删除
      salaryTypeDel(index,val){
        this.$confirm('确认要删除当前薪资类型吗？', '提示', {
            type: 'warning'
        }).then(() => {
            this.$api.found.delCompanySalaryType({companyId:val.id}).then((res) => {
                if(res.status){
                    this.findCompanySalaryTypeList(val.companyId);
                    this.$message({message: '删除成功!', type: 'success'})
                }else{
                    this.$message({message: '删除失败, ' + res.msg, type: 'error'})
                }
            })
        }).catch(() => {})
      },
      // 点击保存
      salaryTypeSave(index,val){
          if(val.add){
              var that = this;
              let salaryTypeAddParameter={
                  companyId:that.companyOneId.id,
                  disablePaging:true,
                  pageNum: 0,
                  pageSize: 0,
                  salaryTypeCode:val.salaryTypeNm, //薪资类型编码
                  salaryTypeNm:val.salaryTypeNm, //薪资类型名称
              };
              this.$api.found.addCompanySalaryType(salaryTypeAddParameter).then((res) => {
                  if(res.status){
                      this.findCompanySalaryTypeList(salaryTypeAddParameter.companyId);
                      this.$message({message: '保存成功 !', type: 'success'})
                  }else{
                      this.$message({message: '保存失败, ' + res.msg, type: 'error'})
                  }
              })
          }else{
              let salaryTypeUpdateParameter={
                  companyId:val.companyId,
                  disablePaging:true,
                  pageNum: 0,
                  pageSize: 0,
                  id:val.id,
                  salaryTypeCode:val.salaryTypeCode, //薪资类型编码
                  salaryTypeNm:val.salaryTypeNm, //薪资类型名称
              };
              this.$api.found.updateCompanySalaryType(salaryTypeUpdateParameter).then((res) => {
                  if(res.status){
                      this.findCompanySalaryTypeList(val.companyId);
                      this.$message({message: '修改成功 !', type: 'success'})
                  }else{
                      this.$message({message: '修改失败, ' + res.msg, type: 'error'})
                  }
              })
          }
      },
      // 点击取消
      salaryTypeCancel(index,val){
          this.salaryTypeData[index].edit = false;
          if(val.add){
            this.salaryTypeData.splice(index,1);
          }
      },
    },
    mounted() {
        var that = this;
        window.addEventListener('setItemEvent',function(e){
            if(e.key == "companyChange"){
                that.companyOneId = JSON.parse(e.newVal);
                that.findCompanySalaryTypeList(that.companyOneId.id);
            }else if(e.key == "companyOneId"){
                that.companyOneId = JSON.parse(e.newVal);
                that.findCompanySalaryTypeList(that.companyOneId.id);
            }
        })
    },
  };
</script>

<style scoped>
  .el-steps--horizontal{
    width: 72%;
    text-align: left;
    margin:20px auto 30px;
  }
  .el-step__title.is-process {
    color:#2ba5f6 !important;
  }
  .el-steps--horizontal .el-step__title{
    font-size:14px !important;
  }
  .found-first{
    width:36%;
    margin:80px auto 0;
  }
  .found-bot{
    position: absolute;
    bottom: -100px;
    width:calc(100% - 40px);
    width:-moz-calc(100% - 40px);
    width:-webkit-calc(100% - 40px);
  }
  .found-bot .found-btn{
    background:#2ba5f6;
    border:1px solid #2ba5f6;
    color:#fff;
  }
  .found-bot .el-button{
    padding: 10px 24px;
  }
  .found-two{
    color:#454545;
    font-size:14px;
    text-align:left;
    margin-bottom: 10px;
  }
  .found-two span{
    color:#2ba5f6;
  }
  .found-three .el-divider--horizontal{
    display:inline-block;
    width: 50%;
    margin:0 0 50px 0;
    float:left;
  }
  .found-three{
    position:relative;
  }
  .found-three-img{
    position: absolute;
    top: 20px;
    right:25%;
    margin-right: -125px;
    width:252px;
  }
  .salary-type-add{
    width: 561px;
    margin: 0px auto;
    text-align:left;
    margin-bottom:10px;
  }
</style>
<!--form表单的样式公共-->
<style>
  .el-step__title{
    font-size:15px;
  }
  .el-step__title.is-success,.el-step__head.is-success {
    color:#fca314;
    border-color: #fca314;
  }
  .el-form-item--mini .el-form-item__content{
    text-align:left;
    line-height: 36px;
  }
  .el-input--mini .el-input__inner,.el-form-item--mini .el-form-item__label{
    width:220px;
    height: 36px;
    line-height: 36px;
  }
  .found-first-upload .el-input{
    width:240px;
    float: left;
  }
  .found-bot .el-form-item__content{
    margin-left:0 !important;
    text-align:center;
  }
  .found-message .el-message__content{
    line-height:24px;
  }
  /*薪资类型*/
  .salary-type-input .el-input,.salary-type-input .el-input__inner{
    height:32px;
    line-height:32px;
    width:260px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Found.vue